import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IpdRoutingModule } from "./ipd-routing.module";
import { IpdRegistrationComponent } from "./ipd-registration/ipd-registration.component";
import { MaterialModule } from "../material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { SharedModule } from "../shared/shared.module";
import { SearchIpdPatientComponent } from "./search-ipd-patient/search-ipd-patient.component";
import { AddmissionPackageComponent } from "./add-service/add-service.component";
import { PatientDocumentComponent } from "./patient-document/patient-document.component";
import { IpdDashboardComponent } from "./ipd-dashboard/ipd-dashboard.component";
import { NgxPaginationModule } from "ngx-pagination";
import { PatientTrackingComponent } from "./ipd-dashboard/patient-tracking/patient-tracking.component";
import { PreopWorkupComponent } from "./ipd-dashboard/preop-workup/preop-workup.component";
import { PatientLabComponent } from "./ipd-dashboard/patient-lab/patient-lab.component";
import { PatientBedTransferComponent } from "./ipd-dashboard/patient-bed-transfer/patient-bed-transfer.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { NgxBarcodeModule } from "ngx-barcode";
import { MatCardModule } from "@angular/material/card";
import { OtconsentPipe } from "./otconsent.pipe";
import { EmrModule } from "app/EMR/emr.module";
import { BillingModule } from "app/billing/billing.module";
import { PrintOTConsentComponent } from "./print-otconsent/print-otconsent.component";
import { PdfViewerModule } from "ng2-pdf-viewer";

import { OTConsentComponent } from "./otconsent/otconsent.component";
import { LazyLoadDataPipe } from "app/lazyload.pipe";
import { PreopDetailComponent } from "./preop-detail/preop-detail.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PreAnaeQuestionComponent } from "./pre-anae-question/pre-anae-question.component";
import { OthelplistPipe } from "./othelplist.pipe";
import { TooltipModule } from "ngx-bootstrap";
import { BulkConsumptionComponent } from './ipd-dashboard/bulk-consumption/bulk-consumption.component';
import { otListComponent } from "./ot-list/ot-list.component";
@NgModule({
  declarations: [
    IpdRegistrationComponent,
    SearchIpdPatientComponent,
    AddmissionPackageComponent,
    PatientDocumentComponent,
    IpdDashboardComponent,
    PatientTrackingComponent,
    PreopWorkupComponent,
    PatientLabComponent,
    PatientBedTransferComponent,
    OtconsentPipe,
    OthelplistPipe,
    PrintOTConsentComponent,
    OTConsentComponent,
    PreopDetailComponent,
    PreAnaeQuestionComponent,
    LazyLoadDataPipe,
    BulkConsumptionComponent,
    otListComponent
  ],
  imports: [
    CommonModule,
    IpdRoutingModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    SharedModule,
    ReactiveFormsModule,
    MatGridListModule,
    NgxPaginationModule,
    DragDropModule,
    NgxBarcodeModule,
    MatCardModule,
    EmrModule,
    BillingModule,
    PdfViewerModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  // exports:[
  //   FormsModule,
  //   ReactiveFormsModule,
  //   PatientDocumentComponent  ],
  exports: [PatientDocumentComponent],
})
export class IpdModule {}
